const trackDYRecsClick = ({ eventCategory, eventAction, eventLabel }) => {
  return {
    hitType: 'event',
    eventCategory,
    eventAction,
    eventLabel,
  };
};

const trackDYAPICampaignAssignment = ({ eventCategory, eventAction, eventLabel }) => {
  return {
    hitType: 'event',
    eventCategory,
    eventAction,
    eventLabel,
  };
};

export { trackDYRecsClick, trackDYAPICampaignAssignment };
